package com.downdogapp.client.views.menu

import com.downdogapp.*
import com.downdogapp.KeyStroke.ENTER
import com.downdogapp.Size.Companion.px
import com.downdogapp.client.MANIFEST
import com.downdogapp.client.Strings
import com.downdogapp.client.controllers.menu.UpdatePasswordViewController
import com.downdogapp.client.widget.*

actual fun createUpdatePasswordView(
  controller: UpdatePasswordViewController
): UpdatePasswordView = object : TopLevelView(), UpdatePasswordView {

  private lateinit var passwordField: SettingsFormField
  private lateinit var confirmPasswordField: SettingsFormField

  override val password get() = passwordField.value
  override val confirmPassword get() = confirmPasswordField.value

  override fun onBecameVisible() {
    passwordField.focus()
  }

  override val root =
    controllerView {
      bg = background(true)
      fg = foreground(true) {
        centeredColumnView {
          pageHeader(
            title =
            if (MANIFEST.hasPassword)
              Strings.EDIT_PASSWORD
            else
              Strings.SET_PASSWORD,
            onBackClicked = controller::onBackClicked
          )

          controller.unlinkMessage?.let {
            centerHorizontally {
              marginBottom = px(40)
              label(it, 16)
            }
          }

          div {
            marginLeft = HORIZONTAL_CONTENT_GUTTER_PX
            marginRight = HORIZONTAL_CONTENT_GUTTER_PX

            passwordField = settingsFormField(isPassword = true) {
              label = Strings.PASSWORD
            }

            confirmPasswordField = settingsFormField(isPassword = true) {
              label = Strings.CONFIRM_PASSWORD
            }
          }

          roundedTextButton(
            text = controller.buttonText,
            marginHorizontal = HORIZONTAL_CONTENT_GUTTER_PX,
            clickFn = controller::onSubmitClicked
          ) {
            marginTop = ROUNDED_TEXT_BUTTON_HEIGHT_PX / 2
          }

          settingsCancelButton(clickFn = controller::onBackClicked)
        }
      }
    }

  override fun onKeyPress(key: KeyStroke?) {
    if (key == ENTER) {
      controller.onSubmitClicked()
    }
  }
}
